<script type="text/javascript">
    import Tab,{ Label } from '@smui/tab';
    import TabBar from '@smui/tab-bar';
    import AuthStore from '../../Auth/Store';
    import ModalWindow from '../ModalWindow.svelte';
    import MeasureTool from "./MeasureTool.svelte";
    import MeasureToolMapControls from "./MeasureToolMapControls.svelte";
    import RoutePlotting from "./RoutePlotting.svelte";
    import RoutePlottingStore from './RoutePlottingStore';
    import RoutePlotWindowStore from './RoutePlotWindowStore';
    import MeasureStore from './Store';
        // {#if User.hasFeature(Feature.MEASURE.VIEW)}					
    // {/if}

    let visible = RoutePlottingStore.meta.visible;

    let measureMenuTabs = ["Route Plotting", "Measure"];
	let activeMeasureTab = RoutePlottingStore.meta.activeTab;
	AuthStore.userInfo.subscribe((data) => {
		$activeMeasureTab = "Route Plotting";
	});
    
    $: {
        if ($visible) {
            RoutePlotWindowStore.actions.initMap();
            MeasureStore.helpers.rebuildGeoJSON();
            RoutePlottingStore.helpers.rebuildGeoJSON();
        }
        else {
            RoutePlotWindowStore.actions.deinitMap();
        }
    }
</script>


<ModalWindow
	title={`Route Plotting`}
	hasCloseButton={true}
	hasBackground={false}
	resizable={true}
	draggable={true}
	fullscreen={false}
	padding={false}
	position="top-right"
	height="70%"
	bind:open={$visible} >

    <TabBar tabs={measureMenuTabs} let:tab bind:active={$activeMeasureTab} class="border-shadow">
        <Tab tab={tab} minWidth><Label>{tab}</Label></Tab>
    </TabBar>

    {#if $activeMeasureTab === "Measure"}
        <MeasureTool />
    {:else if $activeMeasureTab === "Route Plotting"}
        <RoutePlotting/>
    {/if}
    {#if $visible}
        <MeasureToolMapControls />
    {/if}
    
</ModalWindow>